import { Diamond, CircleDot, Clock, Shield, Box, Globe } from "lucide-react";

const features = [
  { icon: Diamond, label: "Nøkkelferdig enhet" },
  { icon: CircleDot, label: "Boutique-standard" },
  { icon: Clock, label: "Klar på 6–10 uker" },
  { icon: Shield, label: "Med 5 års garanti" },
  { icon: Box, label: "Transport i én modul" },
  { icon: Globe, label: "Levering i hele Norge" },
];

export default function FeaturesBar() {
  return (
    <section id="features" className="border-y border-border/60">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center py-10 px-4 border-b lg:border-b-0 border-r border-border/40 last:border-r-0 sm:[&:nth-child(3)]:border-r-0 lg:[&:nth-child(3)]:border-r"
            >
              <f.icon size={20} strokeWidth={1} className="text-primary mb-4" />
              <span className="text-lg tracking-widest-xl font-body font-medium uppercase text-foreground/70">
                {f.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}